"use client";

import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { axiosRequest } from "../../utility/axios";
import { apiBaseUrl } from "../../constant/endpoint";
import { useSelector } from "react-redux";
import ChipCashOutForm from "./chipCashOutForm.js";
import { maskPhone } from "../../helper";

export default function ChipCashOut() {
  const [records, setRecords] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const rowsPerPage = 3;

  const loginSlice = useSelector((state) => state.loginSlice);
  const token = loginSlice.token;

  const fetchCashouts = async () => {
    try {
      const url = `${apiBaseUrl}/chip-cashout?page=1&size=${rowsPerPage}`;
      const res = await axiosRequest("GET", url, token);
      setRecords(res?.data?.cashoutList || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCashouts();
  }, []);

  return (
    <Box sx={{ width: "100%", marginTop: { xs: "55px", md: "95px" } }}>
      <Box p={3} sx={{ padding: { xs: "16px", md: "32px" } }}>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
          <Box>
            <Typography variant="h4" fontWeight="bold">
              Chip Cash-Out
            </Typography>
            <Typography color="text.secondary">
              Record chips returned by players and credit their wallets
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            onClick={() => setOpenDrawer(true)}
            sx={{ borderRadius: 3, height: 45 }}
          >
            New Cash-Out
          </Button>
        </Box>

        <Paper sx={{ borderRadius: 4, overflow: "hidden" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Player</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Total Amount</TableCell>
                <TableCell>Credit Breakdown</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {records.length > 0 ? (
                records.map((rec) => (
                  <TableRow key={rec._id}>
                    <TableCell>
                      {new Date(rec.date).toLocaleString()}
                    </TableCell>
                    <TableCell>
                      <Typography fontWeight={600}>{rec.user_name || "—"}</Typography>
                      <Typography variant="caption" color="text.secondary">{rec.player_id}</Typography>
                    </TableCell>
                    <TableCell>{maskPhone(rec.phone) || "—"}</TableCell>
                    <TableCell>
                      <Typography fontWeight={700} color="success.main">
                        {rec.total_amount?.toLocaleString()}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {rec.credit_breakdown?.float_repay > 0 && (
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Typography variant="caption" color="warning.dark" fontWeight={600}>Float Repay:</Typography>
                          <Typography variant="caption" fontWeight={700} color="warning.dark">
                            {rec.credit_breakdown.float_repay.toLocaleString()}
                          </Typography>
                        </Box>
                      )}
                      {rec.credit_breakdown?.loan_repay > 0 && (
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Typography variant="caption" color="error.main" fontWeight={600}>Loan Repay:</Typography>
                          <Typography variant="caption" fontWeight={700} color="error.main">
                            {rec.credit_breakdown.loan_repay.toLocaleString()}
                          </Typography>
                        </Box>
                      )}
                      {rec.credit_breakdown?.to_winning > 0 && (
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Typography variant="caption" color="success.main" fontWeight={600}>Winning:</Typography>
                          <Typography variant="caption" fontWeight={700} color="success.main">
                            {rec.credit_breakdown.to_winning.toLocaleString()}
                          </Typography>
                        </Box>
                      )}
                      {!rec.credit_breakdown?.float_repay && !rec.credit_breakdown?.loan_repay && !rec.credit_breakdown?.to_winning && (
                        <Typography variant="caption" color="text.disabled">—</Typography>
                      )}
                    </TableCell>
                    <TableCell>{rec.remarks || "—"}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No Cash-Out Records Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>

        <ChipCashOutForm
          open={openDrawer}
          onClose={() => setOpenDrawer(false)}
          refresh={fetchCashouts}
        />
      </Box>
    </Box>
  );
}
